import { assetValueType, ycrAssetType } from "../../../constant";


const assetValueReducer = (state = false, action) => {
    switch (action.type) {
        case assetValueType.FETCH_ASSET_VALUE:
            return action.payload;
        default:
            return state;
    }
}
export default assetValueReducer